import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const images = [
  { src: "https://images.unsplash.com/photo-1706074793638-da28b90ea8ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRlc2lnbiUyMGx1eHVyeXxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85", alt: "Conference room", h: "tall" },
  { src: "https://images.unsplash.com/photo-1715593949273-09009558300a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRlc2lnbiUyMGx1eHVyeXxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85", alt: "Luxury office desk", h: "short" },
  { src: "https://images.unsplash.com/photo-1706074797611-a02f9ed06439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRlc2lnbiUyMGx1eHVyeXxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85", alt: "Interior design", h: "mid" },
  { src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3QlMjBibHVlcHJpbnRzJTIwY29uc3RydWN0aW9uJTIwcHJvamVjdCUyMGV4ZWN1dGlvbnxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85", alt: "Architect working", h: "tall" },
  { src: "https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3QlMjBibHVlcHJpbnRzJTIwY29uc3RydWN0aW9uJTIwcHJvamVjdCUyMGV4ZWN1dGlvbnxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85", alt: "Blueprints", h: "short" },
  { src: "https://images.unsplash.com/photo-1613690399151-65ea69478674?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwc3VwcGx5JTIwY29udGFpbmVyfGVufDB8fHx8MTc4Mzg4MTM4NHww&ixlib=rb-4.1.0&q=85", alt: "Aerial logistics", h: "mid" },
  { src: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1lZXRpbmclMjBib2FyZHJvb218ZW58MHx8fHwxNzgzODgxMzg0fDA&ixlib=rb-4.1.0&q=85", alt: "Boardroom", h: "tall" },
  { src: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwc3VwcGx5JTIwY29udGFpbmVyfGVufDB8fHx8MTc4Mzg4MTM4NHww&ixlib=rb-4.1.0&q=85", alt: "Container yard", h: "short" },
  { src: "https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwc3VwcGx5JTIwY29udGFpbmVyfGVufDB8fHx8MTc4Mzg4MTM4NHww&ixlib=rb-4.1.0&q=85", alt: "Cargo ship", h: "mid" },
];

const heights = { tall: "h-[380px] md:h-[520px]", mid: "h-[280px] md:h-[380px]", short: "h-[220px] md:h-[300px]" };

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[var(--nv-paper)] text-[var(--nv-navy)] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6">
            <div className="overline text-[var(--nv-gold)] flex items-center gap-3">
              <span className="inline-block w-6 h-px bg-[var(--nv-gold)]" />
              <span>Gallery — Frames</span>
            </div>
            <h2 className="mt-6 display text-5xl md:text-7xl" data-testid="gallery-heading">
              Work, in <span className="italic text-[var(--nv-gold)]">context.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-[15px] leading-relaxed text-[var(--nv-navy)]/70">
            A living gallery — interiors, installations, site work and operations. Click any frame to open.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6" data-testid="gallery-grid">
          {images.map((img, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setActive(i)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1], delay: (i % 3) * 0.06 }}
              className={`group relative mb-4 md:mb-6 block w-full overflow-hidden ${heights[img.h]} break-inside-avoid`}
              data-testid={`gallery-item-${i}`}
              aria-label={`Open image ${i + 1}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.7,0,0.3,1)] group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-[var(--nv-navy)]/0 group-hover:bg-[var(--nv-navy)]/25 transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center justify-between text-[var(--nv-paper)] opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                <span className="overline">0{i + 1}</span>
                <span className="font-serif italic text-lg">View</span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed inset-0 z-[80] bg-[var(--nv-navy)]/95 backdrop-blur-md flex items-center justify-center p-6"
            data-testid="gallery-lightbox"
            onClick={() => setActive(null)}
          >
            <button
              type="button"
              onClick={() => setActive(null)}
              className="absolute top-6 right-6 w-11 h-11 rounded-full border border-[var(--nv-paper)]/40 text-[var(--nv-paper)] flex items-center justify-center"
              data-testid="lightbox-close"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
            <motion.img
              key={active}
              initial={{ scale: 0.96, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.96, opacity: 0 }}
              transition={{ duration: 0.5, ease: [0.7, 0, 0.3, 1] }}
              src={images[active].src}
              alt={images[active].alt}
              className="max-w-[90vw] max-h-[85vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
